import React from 'react';

import WidgetTitle from 'components/widget/WidgetTitle.component';

import CN from './WidgetLongerDuration.module.scss';

// NOTE: component not in use for now
const WidgetLongerDuration = ({ tag }) => (
  <div data-bem="WidgetLongerDuration" data-tag={tag} className={CN.component}>
    <div data-bem="WidgetLongerDuration__left" className={CN.col}>
      <WidgetTitle tag="WidgetLongerDuration__left-title">Starts:</WidgetTitle>
      {/* TODO: import SalonCalendar */}
    </div>
    <div data-bem="WidgetLongerDuration__right" className={CN.col}>
      <WidgetTitle tag="WidgetLongerDuration__right-title">Ends:</WidgetTitle>
      {/* TODO: import SalonCalendar */}
    </div>
  </div>
);

export default WidgetLongerDuration;
